export const types = {
  insurers: "[GET] Insurers",
  addInsurers: "[POST] Insurers",
  removeInsurers: "[DELETE] Insurers",
};
